import { createRouter, createWebHistory } from 'vue-router';
import LayoutPublic from '../layouts/Public.vue';
import { routes as managerRoutes } from '@/views/manager/Routes';
import { routes as userRoutes, middleware as userMiddleware } from '@/views/user/Routes';

import store from '../store';
import axios from 'axios';
import {routeAllowed} from '@/access/permissions';

const routes = [
  {
    path: '/',
    name: 'Public',
    component: LayoutPublic,
    children: [
      {
        path: '',
        name: 'PublicHome',
        component: () => import('../views/public/Home'),
        //redirect: (to) => {
        //return '/user/';
        //},
      },
    ],
  },

  {
    path: '/verify',
    name: 'verify',
    component: LayoutPublic,
    children: [
      {
        path: '',
        name: 'PublicVerify',
        component: () => import('../views/public/Verify'),
      },
    ],
  },

  ...managerRoutes,
  //...operatorRoutes,
  ...userRoutes,
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to,from,next)=>{
 if(to.path.startsWith('/manager/')&&!to.path.startsWith('/manager/auth/')){
  store.commit('readManagerToken');const token=store.state.managerToken;
  if(!token)return next({name:'PanelManager-Login',query:{redirect:to.fullPath}});
  try{const response=await axios.post('/v1/managers/auth/validate',{}, {headers:{'x-token-manager':token}});
   if(response.data?.status!=='success'||!response.data.data)throw Error('SESSION');
   store.commit('setManagerToken',token);store.commit('setManagerDetails',response.data.data);
  }catch(e){if(e.message!=='SESSION'&&(!e.response||e.response.status>=500)){window.alert('بررسی دسترسی ممکن نشد؛ دوباره تلاش کنید.');return next(false);}store.commit('clearManagerToken');return next({name:'PanelManager-Login'});}
  if(!routeAllowed(to.path))return next({name:'PanelManager-Home',query:{denied:'1'}});
  return next();
 }
 const record=to.matched.find(x=>x.meta.group===store.state.userRoutesGroupName&&(x.meta.requiresAuth||x.meta.requiresAuthReverse));
 if(record)return userMiddleware(record,next,store.state.userIsAuthenticated);
 return next();
});

export default router;
